// Class: lime.system.Display

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var Display = function() {
}

// Meta

Display.__name__ = "lime.system.Display";
Display.__isInterface__ = false;
Display.prototype = {
	
};
Display.prototype.__class__ = Display.prototype.constructor = $hxClasses["lime.system.Display"] = Display;

// Init



// Statics




// Export

exports.default = Display;